/**
 * @auther Praneeth Geethanjana <geethanjana10@gmail.com>
 * @Since 2/18/2022
 */


import React, {Component} from 'react';
import {Button, Col, Row} from 'reactstrap';
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {Route, withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";


import md5 from 'md5';
import './JoinClasses.scss';
import * as classService from "../../../services/class";
import * as constants from "../../../const/constants";
import * as commonFunc from "../../../utils/commonFunc";
import swal from "sweetalert";
import {lang, language} from "../../../const/language";
import {Modal} from "semantic-ui-react";
import * as validator from "../../../utils/validator";
import * as config from "../../../const/config";
import {isBrowser, isMobile} from "react-device-detect";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {notifyMessage} from "../../../utils/commonFunc";
import Logo from "../../../assets/img/logo/logo-dark.png";
import * as actionLectureCreator from "../../../store/domain/lecturer/action";
import * as actionModalCreator from "../../../store/domain/modal/action";
import * as actionCreator from "../../../store/domain/classes/action";
import * as authService from "../../../services/auth";
import qs from "qs";
import Cookies from "js-cookie";
import * as actionStudentCreator from "../../../store/domain/student/action";

class JoinClasses extends Component{
    state={
        classId:'',
        className: '',
        subject:'',
        startTime:'',
        endTime:'',
        mobile:'',
        password:'',
        meetingType:'',
        hCode:'',
        payment:true,
        notEnrolled:'',
        teacherId:'',
        goClass:null

    }

    textOnChange = async (event) => {
        this.setState({
            payment:true,
            notEnrolled:''
        })
        let name = event.target.name;
        let value = event.target.value;
         if (name === "mobile") if (!validator.onlyDigit.test(value) && value.length !== 0) return;
       await this.setState({[name]: value});
    };

    componentDidMount() {

        let pathname = this.props.location.pathname;
        let array = pathname.split('/');
        let hashCode = (array[array.length - 1]);

        console.log(hashCode);


        if (hashCode.length === 6) {
           classService.JoinClassNavigation(hashCode).then(
                response => {
                    // if (response.success) {
                        classService.getClassDetailsByHashcode(hashCode).then(res => {
                            let classDetails = res.body;
                            let startTime = ''
                            let endTime=''

                            if (classDetails.nextDayOfClass) {
                                startTime = classDetails.nextDayOfClass.split(/[TZ]/)[1]
                            }


                           this.setState({
                                classId:classDetails.id,
                                className:classDetails.name,
                                teacherId: classDetails.teacher.teacherId,
                                subject:classDetails.subject,
                                startTime :startTime? commonFunc.tConvert(startTime) : '',
                                meetingType:classDetails.meetingType,
                                hCode:hashCode,
                            });
                             console.log(classDetails);
                        });
                    // }else{
                    //     console.log("history");
                    // }
                })
               .catch(error => {
                   this.props.spinnerHandler(false);
                   console.log(error);
               })
        }
    }


    joinAndPaymentHandler = async () => {
        await commonFunc.removeCookiesValues();
        let {mobile, password} = this.state;
        const obj = {
            username: mobile,
            password: md5(password),
            grant_type: 'password',
        };
        this.props.spinnerHandler({isSpin: true, type: 5});
        await authService.loginUser(qs.stringify(obj))
            .then(response => {
                this.props.spinnerHandler(false);

                if (response.access_token){
                    console.log(response.access_token);
                    Cookies.set(constants.ACCESS_TOKEN, response.access_token);
                    Cookies.set(constants.REFRESH_TOKEN, response.refresh_token);
                    Cookies.set(constants.VERIFY_CODE, response.verify_code);

                    this.props.userDetailsHandler(response.user.userDetails);

                    if(this.state.goClass === true){
                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                            state: `${this.state.classId}`
                        })
                    }else{
                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                            state: `${this.state.classId}`,
                            search:'paynow=Y'
                        })
                    }
                    return;
                }
                if (!response.success) {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };


    joinClass = () => {

        !validator.mobileNumValidator(this.state.mobile, 1) ? commonFunc.notifyMessage(language[lang].EnterValidMobileNumber) :
            !validator.passwordRegex.test(this.state.password) ? commonFunc.notifyMessage(constants.PASSWORD_TEXT) :

                this.props.spinnerHandler({isSpin:true,type:15});
        let {userObj} = this.props;
        const obj ={
            hCode:this.state.hCode,
            mobile: this.state.mobile,
            password:md5(this.state.password),
        };
        console.log(this.props)
                       classService.joinZoomClasses(obj).then(res => {
                        this.props.spinnerHandler(false);
                        if(!res.success){
                            console.log(res.message)
                            if(res.message === language[lang].notEnrolledText){
                                this.setState({
                                    payment: false,
                                    notEnrolled:"ඔබ මෙම මාසය සඳහා ගෙවීමක් කර නැත",
                                })

                            }else if(res.message === language[lang].pendingText){
                                this.setState({
                                    notEnrolled:language[lang].PaymentPending,
                                })
                            }else {
                                if (res.message === language[lang].notStartedText) {
                                    this.setState({
                                        goClass:true,
                                    })
                                    this.joinAndPaymentHandler();
                                }
                            }
                        if(res.message !== language[lang].notEnrolledText && res.message !== language[lang].pendingText){
                            commonFunc.notifyMessage(res.message,2)
                        }
                        console.log(res.message)


                        }else{

                           //********join part ******
                            if(res.body.type === 'AUTHORIZED'){
                                if(isMobile){
                                    window.open(res.body.joinUrl)
                                }else if(isBrowser){
                                    window.open(res.body.joinUrl)
                                }

                            }else{
                            let obj = {
                                    apiKey: config.ZOOM_API_KEY,
                                    zoomMeetingId:res.body.zoomMeetingId,
                                    zoomMeetingPassword:res.body.zoomMeetingPassword,
                                    zoomSignatureJwt:res.body.zoomSignatureJwt,
                                    userName:res.body.mask,
                                };
                                console.log(obj);
                                if(isMobile){
                                    window.open(`zoomus://zoom.us/join?confno=${obj.zoomMeetingId}&pwd=${obj.zoomMeetingPassword}&uname=${obj.userName}&token=${obj.zoomSignatureJwt}`, '_default')
                                }else if(isBrowser){
                                    window.open(`zoommtg://zoom.us/join?confno=${obj.zoomMeetingId}&pwd=${obj.zoomMeetingPassword}&uname=${obj.userName}&token=${obj.zoomSignatureJwt}`, '_blank')
                                }

                            }
                            //***********************
                        }
                    })
                           .catch(error => {
                            this.props.spinnerHandler(false);
                            console.log(error);
                            commonFunc.notifyMessage('Meeting has not started yet!',2);
                        })


    };


    forgetPasswordHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_FORGOT_ROUTE}`);
}


    render() {

        return(
            <div className="container">

                <Row>
                    <Col className={"col-poly"}>
                        <SectionPolygon/>
                    </Col>
                </Row>


            <div id="hi" className="w-100 d-flex justify-content-center bg-gradient-white">

            <div id="join-class" className=" w-auto flex-column text-center mt-xl-6 mt-lg-6 mt-md-6 mt-sm-7 mt-7">

                <div className={"logo-wrapper"}>
                    <img
                        className={"logo-img"}
                        alt="..."
                        src={Logo}
                    />

                </div>


              <div className="row mt-md-3 mt-lg-3 mt-sm-3 mt-4 mt-xl-4 justify-content-center">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xl-3">
                       <p> <span>Class Name : {this.state.className}</span> </p>

                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xl-3 ">
                      <p><span>Subject : {this.state.subject}</span></p>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xl-3 ">
                       <p><span >Start Time : {this.state.startTime}</span></p>
                  </div>




              </div>



                <div className="row mt-sm-0 mt-md-1 mt-lg-3 mt-xl-3 pt-sm-3 d-flex justify-content-center align-items-center">
                    <Modal.Content>
                    <div className="col-lg-12">
                        <p className={"p-tag"}>{language[lang].MobileNumber}</p>
                    <input id="myClass" className="teach-input bg-translucent-white custom-size-auth text-center " name={"mobile"} type={"telephone"}
                       placeholder={"Enter your mobile number"} onChange={this.textOnChange} value={this.state.mobile}/>
                    </div>

                   <div className="col-lg-12">
                       <p className={"p-tag"}>{language[lang].Password}</p>
                <input id="myClass" className=" teach-input bg-translucent-white custom-size-auth text-center" name={"password"} type={"password"}
                       placeholder={"Enter your password"} onChange={this.textOnChange} value={this.state.password}/>
                   </div>



                        <label className={"forget-text"} onClick={() => this.forgetPasswordHandler()}>{language[lang].ForgotYourPassword}</label>

                    <div id="btn-join" className="col-lg-12 mb-lg-4 mb-xl-5">
                    <Button id="btn-join" disabled={!this.state.mobile || !this.state.password} onClick={this.joinClass} className={" com-btn log-btn blue-gradient-btn custom-size-auth"}>{language[lang].JoinTheZoomClass}</Button>
                    </div>

                        <div className={"col-12"}>
                            <h6 className="enrolled-text mt-3">{this.state.notEnrolled}</h6>
                        </div>

                        {!this.state.payment === true ?  <div className="col-lg-12">
                            <Button onClick={this.joinAndPaymentHandler} className={"mt-2 com-btn log-btn blue-gradient-btn custom-size-auth"}>{language[lang].PurchaseTheClassPass}</Button>
                        </div> : this.state.payment = true

                        }

                    </Modal.Content>
                </div>

            </div>
            </div>
                <CardsFooter/>
            </div>

        );
    }

}

// export default JoinClasses;

const mapStateToProps = (state) => ({
    userObj: state.student.userObj,
    lecturer: state.lecturer.lecturer,
    selectClass: state.classes.selectClass,

});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    userDetailsHandler: data => dispatch(actionStudentCreator.userDetailsHandler(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JoinClasses));

